/**
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: Robin
 * @Last Modified time: 2024-07-24 21:44:55
 * @Introduction: 麦媒云模块路由
 */

import WinpressDemandList from '@/views/winpress/demand/list.vue'
import WinpressDemandDetail from '@/views/winpress/demand/_id.vue'
import ArticleDemandList from '@/views/winpress/article_demand/list.vue'
import ArticleDemandDetail from '@/views/winpress/article_demand/_id.vue'
/* Layout */
import Layout from '@/layout/index.vue'
import { RouteConfig } from 'vue-router/types/router'

const winpressRoute: RouteConfig = {
    path: '/winpress',
    redirect: '/winpress/list',
    component: Layout,
    meta: {
        title: '云发布',
        icon: 'icon-winpress',
        alwaysShow: true                // will always show the root menu
    },
    children: [
        {
            path: 'demand/list',
            component: WinpressDemandList,
            name: 'WinpressDemandList',
            meta: {
                title: '需求列表'
            }
        },
        {
            path: 'demand/:id',
            component: WinpressDemandDetail,
            name: 'WinpressDemandDetail',
            meta: {
                title: '需求详情',
                hidden: true
            }
        },
        {
            path: 'article-demand/list',
            component: ArticleDemandList,
            name: 'ArticleDemandList',
            meta: {
                title: '找人写稿'
            }
        },
        {
            path: 'article-demand/:id',
            component: ArticleDemandDetail,
            name: 'ArticleDemandDetail',
            meta: {
                title: '找人写稿详情',
                hidden: true
            }
        }
    ]
}

export default winpressRoute
